import * as Actions from '../../actions';

const initialState = { data: null };

const listAssignmentConfigurationReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ASSIGNMENT_CONFIGURATION_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listAssignmentConfigurationReducer;
